import { useFrame } from "@react-three/fiber";
import { ConfiguratorOptions } from "@rromikas/configurio";
import React, { PropsWithChildren, useState } from "react";
import { FunctionComponent, useRef } from "react";

interface RotatorProps extends PropsWithChildren {
  rotation: ConfiguratorOptions["rotation"];
}

const Rotator: FunctionComponent<RotatorProps> = ({ children, rotation }) => {
  const objectRef = useRef<THREE.Group>(null);
  const [canAnimate, setCanAnimate] = useState(true);

  useFrame(() => {
    const group = objectRef.current;
    if (group && canAnimate && rotation) {
      group.rotation.x += rotation[0];
      group.rotation.y += rotation[1];
      group.rotation.z += rotation[2];
    }
  });

  return (
    <group onPointerEnter={() => setCanAnimate(false)} onPointerLeave={() => setCanAnimate(true)} ref={objectRef}>
      {children}
    </group>
  );
};

export default Rotator;
